"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstLine = exports.reverseString = exports.getDiv = exports.getTop = exports.getStyle = exports.getHeight = void 0;
var getHeight = function getHeight(elem) {
  return elem.offsetHeight;
};
exports.getHeight = getHeight;
var getStyle = function getStyle(elem, key) {
  return elem.style[key];
};
exports.getStyle = getStyle;
var getTop = function getTop(elem) {
  return elem.getBoundingClientRect().top;
};
exports.getTop = getTop;
var debug = false; // 调试模式开关
var debugCSS = debug ? 'position: static; opacity: 1;' : '';
var getDiv = function getDiv(_a) {
  var _b = _a.text,
    text = _b === void 0 ? '' : _b,
    _c = _a.className,
    className = _c === void 0 ? '' : _c,
    _d = _a.cssText,
    cssText = _d === void 0 ? '' : _d;
  var div = document.createElement('div');
  div.textContent = text;
  div.className = className;
  div.style.cssText = "position:absolute;top:-999em;opacity:0;word-break:break-all;".concat(cssText, ";").concat(debugCSS);
  document.body.appendChild(div);
  return div;
};
exports.getDiv = getDiv;
var reverseString = function reverseString(str) {
  return str.split('').reverse().join('');
};
exports.reverseString = reverseString;
var getFirstLine = function getFirstLine(elem, direction, className, width) {
  if (direction === void 0) {
    direction = 'left';
  }
  if (className === void 0) {
    className = '';
  }
  if (width === void 0) {
    width = '';
  }
  var raw = elem.textContent ? elem.textContent.trim() : '';
  var arr = raw.split('');
  if (direction === 'right') {
    arr === null || arr === void 0 ? void 0 : arr.reverse();
  }
  var div = (0, exports.getDiv)({
    text: raw,
    cssText: width,
    className: className
  });
  div.innerHTML = arr.map(function (item) {
    return "<span>".concat(item, "</span>");
  }).join('');
  var chars = div.querySelectorAll('span');
  var firstTop = (0, exports.getTop)(chars[0]);
  var first = raw;
  for (var i = 1, j = chars.length; i < j; i++) {
    var charTop = (0, exports.getTop)(chars[i]);
    if (charTop > firstTop) {
      first = arr.join('').slice(0, i);
      break;
    }
  }
  !debug && div.remove();
  return direction === 'left' ? first : (0, exports.reverseString)(first);
};
exports.getFirstLine = getFirstLine;